import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { Service, ServiceFormData } from "../Types";
import {
  createService,
  deleteService,
  getServices,
  updateService,
} from "../Api";

export const serviceQueryKeys = {
  services: (search?: string) => ["services", search] as const,
};

export const useServicesQuery = (search?: string, options?: any) => {
  return useQuery<Service[]>({
    ...options,
    queryKey: serviceQueryKeys.services(search),
    queryFn: async (): Promise<Service[]> => {
      const res = await getServices(search);
      if (res.success) {
        return (res.data as Service[]) || [];
      }
      throw new Error(res.message || "Failed to load services");
    },
  });
};

export const useServiceCreateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ServiceFormData) => createService(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
    },
  });
};

export const useServiceUpdateMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: ServiceFormData & { id: string }) => updateService(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
    },
  });
};

export const useServiceDeleteMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteService(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["services"] });
    },
  });
};
